// Generated from openhasp-next/src/font/md-icons.json; do not edit by hand.
// Run: python3 tools/generate_builtin_icons.py --designer <path>
// These 153 icons are included in the default OpenHASP firmware.

export const OPENHASP_BUILTIN_ICONS = {
  // Navigation/Arrows
  'arrow-down': 'E045',
  'arrow-down-box': 'E6C0',
  'arrow-left': 'E04D',
  'arrow-left-box': 'E6C1',
  'arrow-right': 'E054',
  'arrow-right-box': 'E6C2',
  'arrow-up': 'E05D',
  'arrow-up-box': 'E6C3',
  'chevron-down': 'E140',
  'chevron-left': 'E141',
  'chevron-right': 'E142',
  'chevron-up': 'E143',
  'subdirectory-arrow-left': 'E60C',

  // Climate
  'air-conditioner': 'E01B',
  'cloud-search-outline': 'E957',
  'fire': 'E238',
  'radiator': 'E438',
  'radiator-disabled': 'EAD7',
  'radiator-off': 'EAD8',
  'snowflake': 'E717',
  'thermometer': 'E50F',
  'water': 'E58C',
  'water-percent': 'E58E',
  'weather-cloudy': 'E590',
  'weather-fog': 'E591',
  'weather-hail': 'E592',
  'weather-hazy': 'EF30',
  'weather-lightning': 'E593',
  'weather-lightning-rainy': 'E67E',
  'weather-night': 'E594',
  'weather-night-partly-cloudy': 'EF31',
  'weather-partly-cloudy': 'E595',
  'weather-pouring': 'E596',
  'weather-rainy': 'E597',
  'weather-snowy': 'E598',
  'weather-snowy-rainy': 'E67F',
  'weather-sunny': 'E599',
  'weather-windy': 'E59D',
  'weather-windy-variant': 'E59E',
  'white-balance-sunny': 'E5A8',

  // Controls/UI
  'blinds': 'E0AC',
  'blinds-open': 'F011',
  'garage-open-variant': 'F2D4',
  'garage-variant': 'F2D3',
  'window-shutter': 'F11C',
  'window-shutter-alert': 'F11D',
  'window-shutter-open': 'F11E',

  // Appliances/Devices
  'bell': 'E09A',
  'cellphone': 'E11C',
  'dishwasher': 'EAAC',
  'engine': 'E1FA',
  'fan': 'E210',
  'fountain': 'E96B',
  'fridge-outline': 'E28F',
  'kettle': 'E5FA',
  'laptop': 'E322',
  'microwave': 'EC99',
  'recycle-variant': 'F39D',
  'robot-mower-outline': 'F1F3',
  'robot-vacuum': 'E70D',
  'stove': 'E4DE',
  'television': 'E502',
  'trash-can-outline': 'EA7A',
  'tumble-dryer': 'E917',
  'washing-machine': 'E72A',
  'water-pump': 'E58F',

  // Energy/Battery
  'battery-high': 'F2A3',
  'battery-low': 'F2A1',
  'battery-medium': 'F2A2',
  'battery-outline': 'E08E',
  'ev-station': 'E5F1',
  'leaf': 'E32A',
  'lightning-bolt': 'F40B',
  'power': 'E425',
  'power-plug': 'E6A5',
  'solar-panel': 'ED9B',
  'solar-panel-large': 'ED9C',
  'solar-power': 'EA72',
  'solar-power-variant-outline': 'FA74',
  'transmission-tower': 'ED3E',
  'transmission-tower-export': 'F92C',
  'transmission-tower-import': 'F92D',

  // Lights
  'ceiling-light': 'E769',
  'coach-lamp': 'F020',
  'desk-lamp': 'E95F',
  'floor-lamp': 'E8DD',
  'lamp': 'E6B5',
  'lightbulb': 'E335',
  'lightbulb-on': 'E6E8',
  'outdoor-lamp': 'F054',
  'string-lights': 'F2BA',
  'vanity-light': 'F1E1',
  'wall-sconce': 'E91C',

  // Controls/UI
  'check': 'E12C',
  'close': 'E156',
  'cog': 'E493',
  'dots-vertical': 'E1D9',
  'home': 'E2DC',
  'home-outline': 'E6A1',
  'minus': 'E374',
  'plus': 'E415',

  // Places/Rooms
  'bathtub': 'F818',
  'bed': 'E2E3',
  'car': 'E10B',
  'chair-rolling': 'EF48',
  'chair-school': 'E125',
  'coffee': 'E176',
  'desk': 'F239',
  'eiffel-tower': 'F56B',
  'pool': 'E606',
  'shower': 'E9A0',
  'silverware-fork-knife': 'EA70',
  'sofa': 'E4B9',
  'table-furniture': 'E5BC',
  'toilet': 'E9AB',
  'wardrobe': 'EF90',

  // People/Presence
  'account': 'E004',
  'human-greeting': 'F7C4',
  'run': 'E70E',

  // Security
  'alert': 'E026',
  'cctv': 'E7AE',
  'door-closed': 'E81B',
  'door-closed-lock': 'F0AF',
  'door-open': 'E81C',
  'key-variant': 'E30B',
  'lock': 'E33E',
  'lock-open-variant': 'EFC6',
  'shield-check': 'E565',
  'shield-home': 'E68A',
  'shield-lock': 'E99D',
  'window-closed-variant': 'F1DB',

  // Media Controls
  'monitor-speaker': 'EF5F',
  'music': 'E75A',
  'pause': 'E3E4',
  'play': 'E40A',
  'repeat': 'E456',
  'repeat-off': 'E457',
  'repeat-once': 'E458',
  'shuffle': 'E49D',
  'shuffle-disabled': 'E49E',
  'skip-next': 'E4AD',
  'skip-previous': 'E4AE',
  'speaker': 'E4C3',
  'stop': 'E4DB',
  'volume-high': 'E57E',
  'volume-medium': 'E580',
  'volume-mute': 'E75F',

  // Time
  'calendar': 'E0ED',
  'clock-outline': 'E150',
  'history': 'E2DA',
  'timer-outline': 'E51B',

  // Network/Connectivity
  'bluetooth': 'E0AF',
  'wifi': 'E5A9',

};

/** Check if an icon is built into OpenHASP firmware. */
export function isBuiltInIcon(iconName) {
  return iconName in OPENHASP_BUILTIN_ICONS;
}

/** Return the shifted LVGL codepoint as an uppercase hex string. */
export function getBuiltInCodepoint(iconName) {
  return OPENHASP_BUILTIN_ICONS[iconName] || null;
}

/** Return all built-in icon names in stable display order. */
export function getBuiltInIconNames() {
  return Object.keys(OPENHASP_BUILTIN_ICONS).sort();
}

/** Convert a Unicode scalar to a JavaScript UTF-16 string. */
export function codepointToCharacter(codepoint) {
  return String.fromCodePoint(codepoint);
}

/** Return \uXXXX notation, using a surrogate pair above U+FFFF. */
export function codepointToUnicodeNotation(codepoint) {
  if (codepoint <= 0xFFFF) return `\\u${codepoint.toString(16).toUpperCase().padStart(4, '0')}`;
  const value = codepoint - 0x10000;
  const high = 0xD800 + (value >> 10);
  const low = 0xDC00 + (value & 0x3FF);
  return `\\u${high.toString(16).toUpperCase()}\\u${low.toString(16).toUpperCase()}`;
}

/** Get the Unicode character for a built-in icon. */
export function getBuiltInIconCharacter(iconName) {
  const codepoint = OPENHASP_BUILTIN_ICONS[iconName];
  if (!codepoint) return '';
  return codepointToCharacter(parseInt(codepoint, 16));
}

/** Get JSON-safe Unicode escape notation for a built-in icon. */
export function getBuiltInIconUnicodeNotation(iconName) {
  const codepoint = OPENHASP_BUILTIN_ICONS[iconName];
  if (!codepoint) return '';
  return codepointToUnicodeNotation(parseInt(codepoint, 16));
}

export default OPENHASP_BUILTIN_ICONS;
